import { User } from "./User";

export interface ProductData {
  id: string;
  name: string | null;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  uom: string | null;
  system: string | null;
  classification: string | null;
  owner: User | null;
  extras: Record<string, string>;
  item_code: string | null;
  type: string | null;
  quantity_formula: Record<string, any>;
  pending: boolean | null;
  created_by: string | null;
  children: Record<string, any>;
  config: Record<string, any>;
  category: string | null;
  gcgr_type: string | null;
  gcgr_group: string | null;
  gcgr_cost_code: string | null;
  mf: Record<string, string>;
  uf: Record<string, string>;
  notes: string | null;
  total_uc?: number | null;
  labor_uc?: number | null;
  prod_rate?: number | null;
  labor_rate?: number | null;
  material_uc?: number | null;
  equip_uc?: number | null;
  other_uc?: number | null;
  sub_uc?: number | null;
  [key: string]: any; // Allows dynamic keys for sort fields
}

export const excludedKeys = new Set<keyof ProductData>([
  "regional_unit_costs",
  "quantity_formula",
  "mf",
  "uf",
  "extras",
  "children",
  "classification",
  "system",
  "created_by",
  "deleted_at",
  "owner",
  "config",
]);

export interface Product extends Omit<ProductData, keyof typeof excludedKeys> {
  owner_name?: string;
  owner_email?: string;
  [key: string]: any; // Allows dynamic keys for sort fields
}

export interface RegionalUnitCost {
  id: string;
  region: string;
  sub_uc: number | null;
  product: string;
  equip_uc: number | null;
  labor_uc: number | null;
  other_uc: number | null;
  total_uc: number | null;
  extras_uc: Record<string, unknown>;
  prod_rate: number | null;
  created_at: string;
  deleted_at: string | null;
  is_default: boolean;
  labor_rate: number | null;
  uc_formula: Record<string, unknown>;
  updated_at: string;
  material_uc: number | null;
}

/** A `GET /product_labor_crews?region_id=` row: a product's crew in one region. */
export interface ProductLaborCrew {
  id: string;
  product: string;
  labor_crew: string;
  labor_crew_description: string;
  labor_rate_overridden: boolean;
  cbr: number;
  ibr: number;
}

/** One resource rate in a UPC crew's makeup in a region, joined to the resource it prices. */
export interface RegionalLaborCrewMember {
  labor_resource: string;
  resource_description: string;
  item_code: string | null;
  rate_type: "REGULAR" | "OVERTIME" | "DOUBLE";
  rate: number | null;
  quantity: number | null;
}

/** A `GET /labor_crews?region_id=` crew, with its makeup and blended rates in that region. */
export interface RegionalLaborCrew {
  id: string;
  description: string;
  item_code: string | null;
  labor_crew_resource_quantities: RegionalLaborCrewMember[];
  cbr: number;
  ibr: number;
  crew_size: number;
}
